import { PORTAL_API_BASE_URL, PORTAL_DEVICE_NUMBER } from '@/portal/config';

export class PortalApiError extends Error {
  readonly status: number;

  constructor(status: number, message: string) {
    super(message);
    this.name = 'PortalApiError';
    this.status = status;
  }
}

export interface PortalRequestInit {
  method?: 'GET' | 'POST';
  body?: unknown;
  token?: string | null;
  accept?: string;
}

export const portalFetch = (path: string, init: PortalRequestInit = {}): Promise<Response> => {
  const headers: Record<string, string> = {
    'x-device-number': PORTAL_DEVICE_NUMBER,
    Accept: init.accept ?? 'application/json',
  };

  if (init.body !== undefined) {
    headers['Content-Type'] = 'application/json';
  }

  if (init.token) {
    headers.Authorization = `Bearer ${init.token}`;
  }

  return fetch(`${PORTAL_API_BASE_URL}${path}`, {
    method: init.method ?? 'GET',
    headers,
    body: init.body !== undefined ? JSON.stringify(init.body) : undefined,
  });
};

export const portalJson = async <T>(path: string, init: PortalRequestInit = {}): Promise<T> => {
  const response = await portalFetch(path, init);
  if (!response.ok) {
    throw new PortalApiError(response.status, `HTTP ${response.status}`);
  }
  return (await response.json()) as T;
};
